<p class="title">{{'poi.form.create' | translate}}</p>
<form *ngIf="poiForm" [formGroup]="poiForm" (ngSubmit)="submit(poiForm.valid)" class="poi-modal">
  <fieldset class="form__columns--single">
    <div class="form-group fc_c--required">
      <label for="poiGroup">{{'poi.form.poiGroup' | translate}}</label>
      <select class="form-control" formControlName="poiGroupId" name="poiGroupId"
              id="poiGroupId" [required]="true">
        <option *ngFor="let poiGroup of poiGroups" [value]="poiGroup.id">{{poiGroup.value}}</option>
      </select>
      <app-control-messages [control]="poiForm.controls.poiGroupId"></app-control-messages>
    </div>
    <div class="form-group fc_c--required">
      <label for="name">{{'poi.form.name' | translate}}</label>
      <input maxlength="255" formControlName="name" type="text" class="form-control" id="name">
      <app-control-messages [control]="poiForm.controls.name"></app-control-messages>
    </div>
    <div class="form-group">
      <label for="address">{{'poi.form.address' | translate}}</label>
      <input maxlength="255" formControlName="address" type="text" class="form-control" id="address">
    </div>
    <div class="form-group fc_c--required">
      <label for="coordinates">{{'poi.form.coordinates' | translate}}</label>
      <input formControlName="coordinates" type="text" class="form-control" id="coordinates">
      <app-control-messages [control]="poiForm.controls.coordinates"></app-control-messages>
    </div>
    <div class="form-group">
      <label for="comment">{{'poi.form.comment' | translate}}</label>
      <textarea formControlName="comment" rows="5" maxlength="255" class="form-control" id="comment">
    </textarea>
      <app-control-messages [control]="poiForm.controls.comment"></app-control-messages>
    </div>

    <div class="data-form__actions">
      <button type="submit" [disabled]="!poiForm.valid" role="button" class="form__action--primary">
        <i class="ico-save"></i>
        {{'button.save' | translate}}
      </button>
      <a (click)="close()" class="back-to-list" type="button">
        <i class="ico-chevron-left"></i>
        {{'button.back' | translate}}
      </a>
    </div>
  </fieldset>
</form>
